import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  MicrosoftTeamsCallQueue,
  MicrosoftTeamsCallQueuesRef,
  MicrosoftTeamsCallQueueView,
} from '../models/generated/ziroModels';

@Injectable({ providedIn: 'root' })
export class CallQueuesResource {
  private _http = inject(HttpClient);

  getAll(tenantId: string | number): Observable<MicrosoftTeamsCallQueue[]> {
    return this._http.get<MicrosoftTeamsCallQueue[]>(`/services/microsoft/macs/tenants/${tenantId}/call-queues`);
  }

  getDetails(tenantId: string | number, callQueueId: string): Observable<MicrosoftTeamsCallQueueView> {
    return this._http.get<MicrosoftTeamsCallQueueView>(
      `/services/microsoft/views/tenants/${tenantId}/teams-call-queues-details/${callQueueId}`,
    );
  }

  post(tenantId: string | number, callQueue: MicrosoftTeamsCallQueue): Observable<MicrosoftTeamsCallQueuesRef> {
    return this._http.post<MicrosoftTeamsCallQueuesRef>(
      `/services/microsoft/macs/tenants/${tenantId}/call-queues`,
      callQueue,
    );
  }

  put(tenantId: string | number, callQueue: MicrosoftTeamsCallQueue): Observable<void> {
    return this._http.post<void>(`/services/microsoft/macs/tenants/${tenantId}/call-queues`, callQueue);
  }

  delete(tenantId: string | number, callQueueId: string): Observable<void> {
    return this._http.delete<void>(`/services/microsoft/macs/tenants/${tenantId}/call-queues/${callQueueId}`);
  }
}
